module['exports'] = ['مشرق', 'مغرب', 'شمال', 'جنوب', 'نیا', 'جھیل', 'بندرگاہ'];
